import { useQuery } from "@tanstack/react-query";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { getActivityIdAgentsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useActivityAgentsQuery = (id: number) => {
	return useQuery({
		queryKey: ActivityKeys.detailAgents(id),
		queryFn: processResponse(() => getActivityIdAgentsV2(id)),
		enabled: id !== 0,
	});
};
